import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { optionsTimeFrame } from 'Core/defaultValues';

//Components
import { Modal, ModalBody, ModalFooter, Button, Select } from "@gpstrackit/react-controls";

//Actions
import { clearRedux, changeListSearchRequest, generalAuditLogsOpenModal, changeListSearchSubUsersRequest } from 'Redux/actions';
import { useEffect, useState } from "react";
import { getTimeFrame } from 'Utils/helpers';
import CustomCard from 'Components/Card';

//Helpers
import { getDateFormatted, capitalizeFirstLetter } from 'Core/data/Helpers';

//Styles
import './index.scss';

const ChangeList = (props) => {
    const { company } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    let optionsTime = optionsTimeFrame();

    const [timeFrame, setTimeFrame] = useState(optionsTime[2]);

    const { openModal, loading, result, entity, users } = useSelector(state => state.changeListRedux);

    const closeModal = () => {
        dispatch(clearRedux("CHANGE_LIST_AUDIT_LOGS"))
    }

    const handleTimeFrame = (type) => {
        setTimeFrame(type);
        const { start, end } = getTimeFrame(type.Id);
        let payload = {
            accountId: -1,
            dateRange: {
                start: start,
                end: end
            },
            action: [
                "update",
                "insert",
                "delete",
            ],
            entity: {
                name: entity.entityName,
                id: entity.entityId
            },
        }
        dispatch(changeListSearchRequest(payload))
    }

    useEffect(() => {
        if (openModal && entity) {
            if (company) dispatch(changeListSearchSubUsersRequest(company?.id))
            const { start, end } = getTimeFrame(timeFrame.Id);
            let payload = {
                accountId: -1,
                dateRange: {
                    start: start,
                    end: end
                },
                action: [
                    "update",
                    "insert",
                    "delete",
                ],
                entity: {
                    name: entity.entityName,
                    id: entity.entityId
                },
            }
            dispatch(changeListSearchRequest(payload))
        }
    }, [openModal])

    const accountValidation = (name) => {
        let createdBy = name
        var regexSubUser = /^PX_\d+_\d+$/;
        if (name.includes("PX")) {
            if (regexSubUser.test(name)) {
                try {
                    let id = name.split("_")[2];
                    let user = users.find((item) => (item?.id == +id))
                    createdBy = user?.userName
                } catch (error) { }
            } else {
                createdBy = company?.name
            }
        }
       return createdBy || name
    }

    return (
        <Modal
            open={openModal}
            title={messages['common_changes']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div className="change-list-container">
                    <div>
                        <Select
                            id="timeframe"
                            placeholder={messages['activities_main_time_frame']}
                            options={optionsTime}
                            value={timeFrame}
                            textField="Nametag"
                            valueField="Id"
                            onChange={(items = []) => handleTimeFrame(items)}
                        />
                    </div>
                    <div>
                        {
                            result?.items?.length ? (
                                <>
                                    {result?.items?.map((item, index) => {
                                        let action = item.action ? capitalizeFirstLetter(item.action) : ''
                                        return (
                                            <CustomCard
                                                key={index}
                                                info
                                                onClick={() => {
                                                    dispatch(generalAuditLogsOpenModal(true, entity.entityName, entity.entityId, entity.compId, null, item?.updatedOn))
                                                }}
                                            >
                                                <div className="change-list-card">
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_created_at']}</label>
                                                        <span>{getDateFormatted(item?.updatedOn, "date", "datetime")}</span>
                                                    </div>
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_platform']}</label>
                                                        <span>{item?.platform}</span>
                                                    </div>
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_method']}</label>
                                                        <span>{item.method}</span>
                                                    </div>
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_action']}</label>
                                                        <span>{action}</span>
                                                    </div>
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_url']}</label>
                                                        <span>{item.urlReferrer}</span>
                                                    </div>
                                                    <div>
                                                        <label className="change-list-label">{messages['activities_tab_created_by']}</label>
                                                        <span>{accountValidation(item.updatedBy)}</span>
                                                    </div>
                                                </div>
                                            </CustomCard>
                                        )
                                    })}
                                </>
                            ) : <div className="change-list-message">{messages['activities_tab_no_changes']}</div>
                        }
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ChangeList;